// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  cardId: __t.uuid().name("card_id"),
  brandId: __t.uuid().name("brand_id"),
  brandFriendlyName: __t.string().name("brand_friendly_name"),
  heroCdnPath: __t.option(__t.string()).name("hero_cdn_path"),
  colorPrimary: __t.option(__t.string()).name("color_primary"),
  colorText: __t.option(__t.string()).name("color_text"),
  businessType: __t.option(__t.string()).name("business_type"),
  googlePlaceId: __t.option(__t.string()).name("google_place_id"),
  get canonicalAddress() {
    return __t.option(CanonicalAddress).name("canonical_address");
  },
  hasTtwPageTargetProperty: __t.bool().name("has_ttw_page_target_property"),
  linkedNominatedBusinessId: __t.option(__t.string()).name("linked_nominated_business_id"),
  requiresAccessCode: __t.bool().name("requires_access_code"),
  hasTtwPage: __t.bool().name("has_ttw_page"),
  totalInterested: __t.u32().name("total_interested"),
  totalInterestDollars: __t.u32().name("total_interest_dollars"),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  createdAt: __t.timestamp().name("created_at"),
  hasOpenOffering: __t.bool().name("has_open_offering"),
  offeringName: __t.string().name("offering_name"),
  offeringTargetAmountCents: __t.i64().name("offering_target_amount_cents"),
  offeringRaisedCents: __t.i64().name("offering_raised_cents"),
  offeringInvestorCount: __t.u32().name("offering_investor_count"),
  offeringEndDateMs: __t.i64().name("offering_end_date_ms"),
});
